export default "__VITE_ASSET__DNG2C0PS__"